var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 456H272C276.406 456 280 452.422 280 448S276.406 440 272 440H176C171.594 440 168 443.578 168 448S171.594 456 176 456ZM400 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V48C448 21.5 426.5 0 400 0ZM432 464C432 481.645 417.645 496 400 496H48C30.355 496 16 481.645 16 464V400H432V464ZM432 384H16V48C16 30.355 30.355 16 48 16H400C417.645 16 432 30.355 432 48V384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletScreen);
export default __webpack_public_path__ + "static/media/tablet-screen.5bedbf9ed4e01cddc923aebe8e9365cd.svg";
export { ForwardRef as ReactComponent };